class MobileHelper {
  static sendMessage(messageObject) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(messageObject));
    }
  }

  static log(message) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "console", data: { message } }));
    }
  }
}

export default MobileHelper;
